import { styled as t, css as n } from "styled-components";
import { Button as l } from "./atoms-v26.js";
const d = t.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  width: 100%;
`;
t.span`
  background-color: ${({ $color: i, theme: o }) => {
  var r, s;
  return i === "error" ? (r = o == null ? void 0 : o.get) == null ? void 0 : r.call(o, "tokens.background.light.error.default") : (s = o == null ? void 0 : o.get) == null ? void 0 : s.call(o, "tokens.background.light.active");
}};
  height: ${({ $height: i }) => i}px;
  position: absolute;
  top: ${({ $top: i }) => i}px;
  width: ${({ $width: i }) => i}px;
  ${({ $side: i }) => i === "right" ? n`
          right: 0;
        ` : n`
          left: 0;
        `}
`;
const g = t.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`, f = t(l)`
  ${({ $isHidden: i }) => {
  if (i)
    return n`
        visibility: hidden;
      `;
}}
`;
export {
  f as ChangeMonthButton,
  d as Month,
  g as MonthLabelContainer
};
